import * as React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import FileNotFound from "src/components/404";
import CreateGame from "src/components/CreateGame/CreateGame";
import Game from "src/components/Game";
import Home from "src/components/Home";
import JoinGame from "src/components/JoinGame";
import { StyledToastContainer } from "src/components/shared/Toasts/Toasts.components";
import Summary from "src/components/Summary";
import { GameContextProvider } from "src/game/GameContextProvider";
import { SocketContextProvider } from "src/socket/SocketContextProvider";
import "src/styles/fontfaces.css";
import GlobalStyle from "src/styles/GlobalStyle";
import theme from "src/styles/theme";
import {
  CREATE_GAME_PATH,
  GAME_PATH,
  JOIN_GAME_PATH,
  MAIN_PATH,
  SUMMARY,
} from "src/utils/routesPaths";
import { ThemeProvider } from "styled-components";
import { QueryClient, QueryClientProvider } from "react-query";

const queryClient = new QueryClient();
import { ModalProvider } from "src/components/shared/Modal";
import Helmet from "src/components/Helmet";
import Header from "src/components/Header";

const App: React.FunctionComponent = () => (
  <ThemeProvider theme={theme}>
    <SocketContextProvider>
      <QueryClientProvider client={queryClient}>
        <GameContextProvider>
          <GlobalStyle />
          <StyledToastContainer />
          <Helmet />
          <BrowserRouter>
            <ModalProvider>
              <Header />
              <Routes>
                <Route path="*" element={<FileNotFound />} />
                <Route path={MAIN_PATH} element={<Home />} />
                <Route path={CREATE_GAME_PATH} element={<CreateGame />} />
                <Route path={SUMMARY} element={<Summary />} />
                <Route path={JOIN_GAME_PATH} element={<JoinGame />} />
                <Route path={GAME_PATH} element={<Game />} />
              </Routes>
            </ModalProvider>
          </BrowserRouter>
        </GameContextProvider>
      </QueryClientProvider>
    </SocketContextProvider>
  </ThemeProvider>
);

export default App;
